<form-field-label [labelTranslateKey]="'cost'"></form-field-label>

<mat-form-field floatLabel="always" class="cost-container">
	<input
		matInput
		class="cost-input"
		type="number"
		step="1000"
		min="0"
		[placeholder]="'cost' | translate"
		[formControl]="costForm"
		(blur)="onBlur()"
		(keydown.enter)="onBlur()"
	/>
	<span matTextSuffix>kr&nbsp;</span>
	@if (costForm.errors?.pattern) {
		<mat-error align="end">
			{{ 'incorrect_value' | translate }}
		</mat-error>
	}
</mat-form-field>
